<template>
  <div id="app">

    <TopBar/>

    <div class="content">
      <router-view/>
    </div>

  </div>
</template>

<script>
import TopBar from './components/TopBar.vue'

export default {
  name: 'app',
  components: {
    TopBar,
  }
}
</script>

<style lang="scss">
$padding: 16px;
$border-width: 2px;
$topBarHeight: 60px + $padding*2 + $border-width;

@font-face {
  font-family: 'effra';
  src: url('assets/font/effra-regular.eot');
  src: url('assets/font/effra-regular.eot?#iefix') format('embedded-opentype'),
       url('assets/font/effra-regular.woff') format('woff'),
       url('assets/font/effra-regular.ttf') format('truetype'),
       url('assets/font/effra-regular.svg#effraregular') format('svg');
}

body {
  background: rgba(0, 0, 0, 0.9);
  padding: 0;
  margin: 0;
}

#app {
  font-family: effra, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
}

.content {
  padding-top: $topBarHeight;
  max-width: 1200px + $padding*4;
  margin-left: auto;
  margin-right: auto;

  @media (max-height: 500px) {
    padding-top: $topBarHeight - $padding*2;
  }
}

a {
  color: white;
  text-decoration-color: grey;
  text-decoration-style: dotted;
  text-underline-position: under;

  &:hover {
    text-decoration-color: white;
  }
}
</style>
